<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 pa-0 pr-6 pt-6>
                    <v-layout row wrap justify-end>
                        <v-btn @click="printReceipt" color="red" dark>
                            In phiếu
                        </v-btn>
                        <v-btn v-if="currentItem.Status != export_receipt_status_enum.hoan_thanh" @click="saveData" dark class="ml-2">
                            Lưu phiếu
                        </v-btn>
                        <v-btn v-if="currentItem.Status == export_receipt_status_enum.da_chuan_bi" @click="exportReceipt" color="blue" dark class="ml-2">
                            Xuất kho
                        </v-btn>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md4 sm12 xs12>
                    <v-layout row wrap pa-0 ma-0>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-autocomplete label="Khách hàng" v-model="currentItem.UID" :items="customers" item-text="FilterName" item-value="ID" @change="onSelectCustomer"></v-autocomplete>
                            <v-select label="Trạng thái" :items="export_receipt_status" v-model="currentItem.Status" item-text="name" item-value="value" disabled></v-select>
                            <mh-date-picker plabel="Ngày xuất" class="input-group--focused date-picker" v-model="currentItem.ExportDate" disabled></mh-date-picker>
                            <v-textarea class="pt-8" rows="3" label="Nhập ghi chú phiếu xuất" v-model="currentItem.Note"></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex lg8 md8 sm12 xs12>
                    <v-layout row wrap>
                        <v-flex lg12 md12 sm12 pb-0>
                            <v-radio-group v-model="transactionGroup" row v-if="currentItem.Status != export_receipt_status_enum.hoan_thanh" :disabled="!modifyId">
                                <v-radio key="1" label="Nhập phiếu" :value="1"></v-radio>
                                <v-radio key="2" label="Kiểm phiếu" :value="2"></v-radio>
                            </v-radio-group>
                            <v-text-field label="Mã vận đơn" v-model="transactionCode" @change="onTransactionCodeChanged" ref="trancode" v-if="currentItem.Status != export_receipt_status_enum.hoan_thanh" :disabled="!modifyId"></v-text-field>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-data-table :headers="headers" :items="currentPackages" disable-pagination hide-default-footer>
                                <template v-slot:item="{ item }">
                                <tr>
                                        <td>{{ item.TransactionCode }}</td>
                                        <td>{{ (item.OrderType == 1 ? 'MD' : 'KG') + item.OrderID }}</td>
                                        <td>{{ item.StoreVNState | display_value(package_states) }}</td>
                                        <td class="text-center">
                                            <i v-if="item.ReceiptState === 1" title="Đã khớp" style="color: green; font-size: 18px;" class="fa fa-check-circle"></i>
                                            <i v-else title="Không khớp" style="color: red; font-size: 18px;" class="fa fa-times-circle"></i>
                                        </td>
                                        <td class="text-center">
                                            <v-icon v-if="currentItem.ID > 0 && currentItem.Status == export_receipt_status_enum.phieu_nhap" small @click="deleteTransaction(item)">fa-trash-alt</v-icon>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import Vue from 'vue';
import configs from "@/configs";
import _ from "lodash";
import { sendErrorNotice, makeid } from "@/commons/utils";
import MHDatePicker from "@/components/daterange/MHDatePicker";
import { request_list, print_export_receipt_order } from '@/commons/hpod';
import firebase from 'firebase';

export default {
    components: {
        "mh-date-picker": MHDatePicker
    },
    data() {
        return {
            selectedGroup: 0,
            transactionGroup: 1,
            transactionCode: '',
            export_receipt_status: configs.EXPORT_RECEIPT_STATUS,
            export_receipt_status_enum: configs.EXPORT_RECEIPT_STATUS_ENUM,
            request_ids: [],
            files: [],
            uploading: false,
            headers: [
                {
                    text: "Mã vận đơn",
                    value: "TransactionCode",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Mã đơn",
                    value: "OrderID",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Vận hành kho",
                    value: "StoreVNState",
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "TT kiểm",
                    value: "ReceiptState",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: ""
                }
            ]
        }
    },
    computed: {
        ...mapState({
            loading: state => state.exportReceipt.loading,
            currentItem: state => state.exportReceipt.selected,
            currentPackages: state => state.exportReceipt.packages.data,
            customers: state => _.map(state.customer.master.data, (item) => {return {...item, FilterName: `${item.ID}-${item.Username}`}}),
            staffs: (state) => _.filter(state.commons.all_users, function(o) { return ((o.RoleType & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN);}),
            configuration: state => state.configuration.selected,
        }),
        modifyId() {
            return Number(this.$route.params.Pid);
        },
        package_states() {
            return this.configuration && this.configuration.PackageState ? JSON.parse(this.configuration.PackageState) : [];
        },
        adminRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin);
        },
        paymentRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment);
        },
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("exportReceipt/getDetail", this.modifyId);
                this.$store.dispatch('exportReceipt/getTransactionList', {
                    pagination: {
                        mustSort: true,
                        sortDesc: [1],
                        sortBy: ["ModifiedDate"]
                    },
                    filter: [
                    {
                        column: "ExportReceiptID",
                        value: this.modifyId,
                        condition: "equal"
                    }]
                });
            }
            else {
                this.$store.commit("exportReceipt/setDetail", { data: {
                        ID: 0,
                        Status: 1
                    }
                });
                this.$store.commit('exportReceipt/setTransactionList', {data: []})
            }
        },
        saveData() {
            this.$store.dispatch("exportReceipt/setDetail", {
                data: {
                    ...this.currentItem,
                    Files: JSON.stringify(this.files),
                    RequestIDs: this.request_ids
                },
                id: this.currentItem.ID
            }).then((ret) => {
                if(!this.modifyId) {
                    this.$router.replace({
                        name: "ExportReceiptDetail",
                        params: {
                            Pid: ret.data.ID,
                            title: `Chi tiết phiếu xuất (#${ret.data.ID})`
                        }
                    });
                }
                else {
                    this.refreshData();
                }
            });
        },
        exportReceipt() {
            if(!((this.currentItem.SaleFeeShipBS > 0 && this.currentItem.StoreFeeShip > 0) || (this.currentItem.SaleFeeShipBS == 0 && this.currentItem.StoreFeeShip == 0)) && this.selectedGroup == 1 && !this.currentItem.IsFreeShip) {
                sendErrorNotice('Chưa có phí ship, không thể xuất kho.')
                return;
            }
            if(!((this.currentItem.SaleFeeShip > 0 && this.currentItem.StoreFeeShip > 0) || (this.currentItem.SaleFeeShip == 0 && this.currentItem.StoreFeeShip == 0)) && !this.selectedGroup && !this.currentItem.IsFreeShip) {
                sendErrorNotice('Chưa có phí ship, không thể xuất kho.')
                return;
            }
            this.$store.dispatch("exportReceipt/setDetail", {
                data: {
                    Status: this.export_receipt_status_enum.hoan_thanh,
                    IsFreeShip: this.currentItem.IsFreeShip
                },
                id: this.currentItem.ID
            }).then((ret) => {
                this.refreshData();
            });
        },
        printReceipt() {
            const frame_printing = print_export_receipt_order(this.currentItem, this.currentPackages, true);
            var doc = document.getElementById('print_frame').contentWindow.document;
            doc.open();
            doc.write(frame_printing);
            doc.close();
            setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
        },
        deleteTransaction(item) {
            this.$store.dispatch("orderTransaction/setDetail", {
                data: {
                    ExportReceiptID: 0,
                    ReceiptState: 0
                },
                id: item.ID,
                cb: () => {this.refreshData()}
            });
        },
        onTransactionCodeChanged() {
            if(this.transactionCode == '') {
                return;
            }
            // Thêm mã vận đơn vào phiếu xuất
            if(this.transactionGroup == 1) {
                var param = {
                    filter: [{
                        column: "TransactionCode",
                        value: (this.transactionCode.indexOf('v-') >= 0 ? '' : 'v-') +this.transactionCode.trim(),
                        condition: "s_equal"
                    }]
                };
                const checkTran = _.find(this.currentPackages, {TransactionCode: (this.transactionCode.indexOf('v-') >= 0 ? '' : 'v-') +this.transactionCode.trim()})
                if(checkTran) {
                    this.transactionCode = '';
                    this.$nextTick(() => this.$refs.trancode.focus());
                    sendErrorNotice('Mã vận đơn đã tồn tại trong phiếu xuất.')
                    return;
                }
                request_list('export-receipt/transactions', ret => {
                    if(ret.data.length > 0) {
                        let item = ret.data[0];
                        this.transactionCode = '';
                        this.$nextTick(() => this.$refs.trancode.focus());
                        if(item.Status != configs.PACKAGE_STATUS_ENUM.DA_VE_KHO_NHAN) {
                            sendErrorNotice('Mã vận đơn không có trong kho.')
                            return;
                        }
                        if(item.ExportReceiptID > 0) {
                            sendErrorNotice(`Mã vận đơn đã xuất trong phiếu #${item.ExportReceiptID}.`)
                            return;
                        }
                        if(!item.UID) {
                            sendErrorNotice('Mã vận đơn không có thông tin khách.')
                            return;
                        }
                        if(item.UID != this.currentItem.UID) {
                            sendErrorNotice('Mã vận đơn của khách hàng khác.')
                            return;
                        }
                        this.currentPackages.unshift(item);
                        this.$store.dispatch("orderTransaction/setDetail", {
                            data: {
                                ExportReceiptID: this.currentItem.ID
                            },
                            id: item.ID
                        });
                    }
                    else {
                        sendErrorNotice('Không tìm thấy mã vận đơn.')
                    }
                }, Vue.http, param, this.$store.state.authentication.token);
            }
            // Kiểm tra xem mã vận đơn có tồn tại trong phiếu chưa
            else {
                const checkTran = _.find(this.currentPackages, {TransactionCode: (this.transactionCode.indexOf('v-') >= 0 ? '' : 'v-') +this.transactionCode.toLowerCase().trim()})
                if(checkTran) {
                    this.transactionCode = '';
                    this.$nextTick(() => this.$refs.trancode.focus());
                    this.$store.dispatch("orderTransaction/setDetail", {
                        data: {
                            ReceiptState: 1
                        },
                        id: checkTran.ID,
                        cb: () => {this.saveData()}
                    });

                    return;
                }
                else {
                    sendErrorNotice('Không tìm thấy mã vận đơn trong phiếu xuất.')
                }
            }
            
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username", "PhoneNumber", "Address"]
            });
        },
        onSelectCustomer() {
            let customer = _.find(this.customers, {'ID': this.currentItem.UID});
            this.currentItem.Username = customer ? customer.Username : '';
            this.currentItem.Address = customer ? customer.Address : '';
            this.currentItem.Phone = customer ? customer.PhoneNumber : '';
        },
    },
    mounted() {
        this.refreshData();
        this.getCustomerList();
        this.$store.dispatch("commons/getAllUsers");
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>
<style scoped>
.remove-image {
    position: absolute !important;
    transform: translate(50%, -130%);
    margin-left: 14px;
}
</style>